<ul class="ols-radio">
  <li *ngFor="let antwoord of filterAntwoordenOpProduct(vraag.antwoorden)" (click)="radiobuttonClicked(antwoord.id)"
    (keyup.Space)="radiobuttonClicked(antwoord.id)" [id]="geefMeetid(vraag, antwoord)"
    [ngClass]="[selectedId == antwoord.id ? 'selected' : '']" [tabindex]="0">
    <div class="circle">
      <div class="outer">
        <div class="inner"></div>
      </div>
    </div>
    <div class="ols-content">
      <ng-container *ngIf="antwoord.icon">
        <div [ngClass]="['icon-verz', antwoord.icon]"></div>
      </ng-container>
      <div [innerHTML]="geefTitel(antwoord)" class="ols-heading-5"></div>
      <ng-container *ngIf="antwoord.antwoordregels">
        <div *ngFor="let regel of antwoord.antwoordregels" class="ols-subtext">{{regel}}</div>
      </ng-container>
      <ng-container *ngIf="antwoord.antwoord_bullets">
        <div data-hj-suppress *ngFor="let bullet of antwoord.antwoord_bullets">{{bullet}}</div>
      </ng-container>
    </div>
  </li>
</ul>
<p class="error-block" *ngIf="submitClicked && selectedId === ''">Maak alsjeblieft een keuze</p>